import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { formatDate, formateDateTime } from "../../../utils/commonFunctions";
import { deleteIcon, tableEditIcon } from "../../../assets/images";
import { CircularAvatar } from "../../commons";
import TableToggleSwitch from "../../commons/TableToggleSwitch";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FONT_COL_CODES, STAGE_COLOR_CODES } from "../../../constant/colors";
type AppProps = {
  tableHeader: TableHeadersType[];
  data: any;
  type?: string;
  handleEditMasterData: (data: any) => void;
  handleEnableDisableClick?: (data: any) => void;
  handleDelete?: (id: string) => void;
  isEditPresent?: boolean;
  isDeletePresent?: boolean;
};
const MaterDataTableData = ({
  tableHeader,
  data,
  type,
  handleEditMasterData,
  handleEnableDisableClick,
  handleDelete,
  isEditPresent,
  isDeletePresent,
}: AppProps) => {
  const backColor = (type: string) => {
    let backgroundColor;
    let fontColor;

    if (type == "expenses") {
      backgroundColor = STAGE_COLOR_CODES[1];
      fontColor = FONT_COL_CODES[1];
    } else if (type == "revenues") {
      backgroundColor = STAGE_COLOR_CODES[4];
      fontColor = FONT_COL_CODES[4];
    }

    return {
      backgroundColor,
      fontColor,
    };
  };

  const styleColor = (type: string) => {
    const { backgroundColor, fontColor } = backColor(type);

    return {
      marginTop: "20px",
      padding: "4px 12px",
      color: fontColor,
      background: backgroundColor,
      borderRadius: "16px",
    };
  };

  const blank = () => {
    return {};
  };
  return (
    <>
      {data &&
        data?.length > 0 &&
        data?.map((itemData: any) => {
          return (
            <tr key={itemData?._id}>
              {tableHeader?.map((item: TableHeadersType) => {
                // Future Use
                // if (itemData[item.value]) {
                //   return (
                //     <td className="text-left">
                //       {itemData[item.value] ? itemData[item.value] : "NA"}
                //     </td>
                //   );
                // }
                if (item?.value === "department_name") {
                  return <td>{itemData?.department_name}</td>;
                } else if (item?.value === "pdf_template_name") {
                  return <td>{itemData?.pdf_template_name}</td>;
                } else if (item?.value === "invoice_type") {
                  return (
                    <td>
                      <span
                        style={
                          itemData?.invoice_type
                            ? styleColor(itemData?.invoice_type)
                            : blank()
                        }
                      >
                        {itemData?.invoice_type == "expenses"
                          ? "Expense"
                          : itemData?.invoice_type == "revenues"
                          ? "Sales"
                          : ""}
                      </span>
                    </td>
                  );
                } else if (item?.value === "tds_rate") {
                  return (
                    <td>
                      {itemData?.tds_rates[0]?.tds_rate
                        ? `${itemData?.tds_rates[0]?.tds_rate} %`
                        : "NA"}
                    </td>
                  );
                } else if (item?.value === "tcs_rate") {
                  return (
                    <td>
                      {itemData?.tcs_rates[0]?.tcs_rate
                        ? `${itemData?.tcs_rates[0]?.tcs_rate} %`
                        : "NA"}
                    </td>
                  );
                } else if (item?.value === "threshold") {
                  return (
                    <td>
                      {itemData?.threshold ? `${itemData?.threshold}` : "0"}
                    </td>
                  );
                } else if (item?.value === "threshold_amount") {
                  return (
                    <td>
                      {itemData?.threshold_amount
                        ? `${itemData?.threshold_amount}`
                        : "0"}
                    </td>
                  );
                } else if (item?.value === "scope_of_work_name") {
                  return <td>{itemData?.scope_of_work_name}</td>;
                } else if (item?.value === "skill_name") {
                  return <td>{itemData?.skill_name}</td>;
                } else if (item?.value === "tds_date") {
                  return (
                    <td>{formatDate(itemData?.tds_rates?.[0]?.tds_date)}</td>
                  );
                } else if (item?.value === "tcs_date") {
                  return (
                    <td>{formatDate(itemData?.tcs_rates?.[0]?.tcs_date)}</td>
                  );
                }
                if (item?.value == "status") {
                  return type == "scopeOfWork" ||
                    type == "skills" ||
                    type == "qualification" ? (
                    <td>{itemData?.status === true ? "Active" : "Inactive"}</td>
                  ) : (
                    <TableToggleSwitch
                      handleEnableDisableClick={handleEnableDisableClick}
                      status={itemData?.status}
                      tableData={itemData}
                    />
                  );
                } else if (item?.value === "created_at") {
                  return (
                    <td
                      style={{
                        minWidth:
                          type === "tcs" || type === "tds" ? "221px" : "",
                      }}
                    >
                      <div
                        className="ml-2"
                        style={{
                          display: "flex",
                          justifyContent: "left",
                          alignItems: "center",
                          gap: "7px",
                        }}
                      >
                        {type == "pdfTemplate" ? (
                          <div style={{ marginTop: "-16px" }}>
                            <CircularAvatar
                              name={`${itemData?.updated_by?.first_name} ${itemData?.updated_by?.last_name}`}
                              image={
                                itemData?.updated_by?.profile_pic &&
                                itemData?.updated_by?.profile_pic?.file_url
                              }
                            />
                          </div>
                        ) : (
                          <div style={{ marginTop: "-16px" }}>
                            <CircularAvatar
                              name={itemData?.updated_by?.name}
                              image={
                                itemData?.updated_by?.profile_pic &&
                                itemData?.updated_by?.profile_pic?.file_url
                              }
                            />
                          </div>
                        )}

                        <div>
                          <span>{itemData?.updated_by?.name}</span>
                          {type == "tcs" ||
                          type == "tds" ||
                          type == "pdfTemplate" ? (
                            <span>
                              {itemData?.updated_by?.first_name}{" "}
                              {itemData?.updated_by?.last_name}
                            </span>
                          ) : (
                            ""
                          )}
                          <p style={{ color: "#6e7491" }}>
                            {formateDateTime(itemData?.updated_at)}
                          </p>
                        </div>
                      </div>
                    </td>
                  );
                } else if (item?.value === "Edit") {
                  return (
                    <td style={{ width: "50px", textAlign: "start" }}>
                      <div className="d-flex">
                        {isEditPresent && (
                          <span className="d-inline-block pointer">
                            <div
                              style={{
                                color: "#d43",
                                fontSize: 20,
                                width: "30px",
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="send-email-tooltip">
                                    Edit
                                  </Tooltip>
                                }
                              >
                                <img
                                  onClick={() =>
                                    handleEditMasterData?.(itemData)
                                  }
                                  src={tableEditIcon}
                                  alt=""
                                />
                              </OverlayTrigger>
                            </div>
                          </span>
                        )}
                        {isDeletePresent && (
                          <span className="d-inline-block pointer">
                            <div
                              style={{
                                color: "#d43",
                                fontSize: 20,
                                width: "30px",
                              }}
                            >
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip id="send-email-tooltip">
                                    Delete
                                  </Tooltip>
                                }
                              >
                                <img
                                  onClick={() =>
                                    handleDelete?.(
                                      type === "tds"
                                        ? itemData?.tds_id
                                        : type === "tcs"
                                        ? itemData?.tcs_id
                                        : type === "pdfTemplate"
                                        ? itemData?.pdf_template_id
                                        : itemData?._id
                                    )
                                  }
                                  src={deleteIcon}
                                  alt="Delete"
                                />
                              </OverlayTrigger>
                            </div>
                          </span>
                        )}
                      </div>
                    </td>
                  );
                } else {
                  return <td>{itemData[item?.value]}</td>;
                }
              })}
            </tr>
          );
        })}
    </>
  );
};

export default MaterDataTableData;
